<template>
	<div class="py-6 pl-7 pr-8 flex justify-center gap-x-6 lg:justify-between lg:gap-x-0 border-y border-gray-200">
		<div class="flex gap-2 items-center">
			<CalendarIcon />
			<div v-if="arrivalDate">
				{{ arrivalDate }}
				<template v-if="departureDate && nights > 0">
					&ndash; {{ departureDate }} &middot; {{ t('nights_count', { n: nights }, nights) }}
				</template>
			</div>
		</div>
		<div class="hidden lg:flex gap-2 items-center" data-cy="arrival-info-arrival_time">
			<ClockIcon />
			{{ $flowstore.checkout.data.arrival.time }}
		</div>
		<div class="flex gap-2 items-center" data-cy="arrival-info-persons_count">
			<PersonsIcon />
			<span class="lg:hidden">{{ personsCount }} {{ t('persons_short') }}</span>
			<span class="hidden lg:inline">{{ personsCount }} {{ t('persons', personsCount) }}</span>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { differenceInCalendarDays, format, parse } from 'date-fns';
import { dateLocale as locale } from '@/config';
import { useI18n } from 'vue-i18n';
import { useFlowStore } from '@/stores/useFlowStore';

import ClockIcon from '@/theme/icons/clock.svg?component';
import CalendarIcon from '@/theme/icons/calendar.svg?component';
import PersonsIcon from '@/theme/icons/group_grey.svg?component';

const { t } = useI18n();
const flowStore = useFlowStore();

const personsCount = computed(() => flowStore.checkout.data.persons_count);

const arrivalDate = computed(() => formatDate(flowStore.checkout.data.arrival.date));
const departureDate = computed(() => formatDate(flowStore.checkout.data.departure?.date));

const nights = computed(() => {
  const arrival = parseDate(flowStore.checkout.data.arrival.date);
  const departure = parseDate(flowStore.checkout.data.departure?.date);

  return arrival && departure ? differenceInCalendarDays(departure, arrival) : 0;
});

function parseDate(date: string | null): Date | null {
  return date ? parse(date, 'yyyy-MM-dd', new Date()) : null;
}

function formatDate(date: string | null): string | null {
  const parsed = parseDate(date);

  // Strip the abbreviation dot the locale adds ("3 sep." -> "3 sep")
  return parsed ? format(parsed, 'd MMM', { locale }).replace(/\./g, '') : null;
}
</script>
